import { call, take, fork, all, put } from 'redux-saga/effects';
// import { PatientsActionTypes } from '../patients/type';
import { StaticToast } from 'src/components/common';
import { SugarBloodActionTypes } from './type';
import { fetchJson } from 'src/utils/fetch';
import format from 'src/utils/format';


export function* fetch_sugarblood_data() {
  while (true) {
    const action = yield take(SugarBloodActionTypes.FETCH_SUGARBLOOD_DATA);
    try {
      const { options = {} } = action;
      let res: any = {};
      // let data: any = [];
      // if (init) {

      // } else {
      //   res = yield call(fetchJson, {
      //     url: '/api/api/v1/patient/bloodSugar/list/page',
      //     type: 'POST',
      //     data: {
      //       currentPage: 1,
      //       pageSize: 7,
      //       ...options
      //     },
      //     action
      //   });
      //   if (res && res.code === '0') {
      //     const { result = [] } = res;
      //     data = result;
      //   }
      // }

      res = yield call(fetchJson, {
        url: '/api/api/v1/patient/bloodSugar/list/page',
        type: 'POST',
        isloading: false,
        action,
        data: {
          currentPage: 1,
          pageSize: 7,
          ...options
        }
      })
      if (res && res.code === '0') {
        const { result: { resultList = [] } = {} } = res;
        yield put({ type: SugarBloodActionTypes.INIT_SUGARBLOOD_SUCCESS, data: resultList, patientId: options.patientId });
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_sugarblood_data--------' + error.message);
    }
  }
}

export function* fetch_sugarblood_recent() {
  while (true) {
    const action = yield take(SugarBloodActionTypes.FETCH_SUGARBLOOD_RECENT);
    try {
      const { patientId } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/bloodSugar/list',
        type: 'POST',
        isloading: false,
        action,
        data: {
          patientId,
          recordEndTime: `${format.date(Date.now(), 'yyyy-MM-dd')} 23:59:59`,
          recordStartTime: `${format.date(format.timeForMat(30), 'yyyy-MM-dd')} 00:00:00`,
        }
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        yield put({ type: SugarBloodActionTypes.FETCH_SUGARBLOOD_RECENT_SUCCESS, data: result });
      }

    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_sugarblood_recent--------' + error.message);
    }
  }
}

export function* fetch_sugarblood_history() {
  while (true) {
    const action = yield take(SugarBloodActionTypes.FETCH_SUGARBLOOD_HISTORY);
    try {
      const { options } = action;
      const data: any = {};
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/bloodSugar/list',
        type: 'POST',
        isloading: true,
        action,
        data: {
          ...options
        }
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        result.length && result.forEach(element => {
          const date = format.date(element.recordTime, 'yyyy-MM-dd');
          if (data[date]) {
            data[date] = [...data[date], element];
          } else {
            data[date] = [element];
          }
        });
        yield put({ type: SugarBloodActionTypes.FETCH_SUGARBLOOD_HISTORY_SUCCESS, data });
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_sugarblood_history--------' + error.message);
    }
  }
}

export function* save_sugarblood() {
  while (true) {
    const action = yield take(SugarBloodActionTypes.SAVE_SUGARBLOOD);
    try {
      const { options, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/bloodSugar/save',
        type: 'POST',
        // isloading: false,
        action,
        data: {
          ...options
        }
      });
      if (res && res.code === '0') {
        typeof onSuccess === 'function' && onSuccess()
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('save_sugarblood--------' + error.message);
    }
  }
}

export default function* root() {
  yield all([

    fork(fetch_sugarblood_data),
    fork(fetch_sugarblood_recent),
    fork(fetch_sugarblood_history),
    fork(save_sugarblood),
  ])
}